// @ts-strict-ignore
import * as React from 'react';

import {SelectReact} from 'common/components/select';
import {ButtonSize} from 'common/components/button/constants';
import {SelectTheme} from 'common/components/select/constants';
import {InputReact} from 'common/components/input';
import {InputChangeEvent, InputSize} from 'common/components/input/types';
import {ChangeEvent} from 'common/components/select/types';
import {TimeUnit} from 'common/widgets/date-range-picker/models/types';
import {Property} from 'common/query-builder/query-block/properties-menu/types';

import styles from './index.module.styl';

/**
 * Defines a offset. used in both
 * SCDOffsetBlock
 * RevenueChangeBlock
 */
export function Offset({
  value,
  onChange,
}: {
  value: Property['scdOffset'];
  onChange: (offset: Property['scdOffset']) => void;
}) {
  if (!value) {
    return null;
  }
  const {value: offsetValue, unit} = value;

  return (
    <div className={styles.customizeOffset}>
      {offsetValue === `$start` && <div className={styles.startOfInterval}>As of start of Interval</div>}
      {typeof offsetValue === `number` && (
        <>
          <div className={styles.text}>As of</div>
          <InputReact
            type='number'
            className={styles.input}
            min={`1`}
            size={InputSize.Small}
            value={`${-offsetValue || 0}`}
            onChange={(ev: InputChangeEvent) => {
              const changedValue = Number(ev.detail.value);
              onChange({
                value: -changedValue,
                unit,
              });
            }}
          />
          <SelectReact
            theme={SelectTheme.QbSubitem}
            size={ButtonSize.Small}
            menuWidth={140}
            sections={[
              {
                items: [
                  {
                    label: `Days`,
                    value: TimeUnit.Day,
                  },
                  {
                    label: `Weeks`,
                    value: TimeUnit.Week,
                  },
                  {
                    label: `Months`,
                    value: TimeUnit.Month,
                  },
                  {
                    label: `Quarters`,
                    value: TimeUnit.Quarter,
                  },
                  {
                    label: `Years`,
                    value: TimeUnit.Year,
                  },
                ].map((item) => ({
                  ...item,
                  isSelected: item.value === unit,
                })),
              },
            ]}
            onChange={(ev: ChangeEvent<TimeUnit>) => {
              const {item} = ev.detail;
              onChange({
                value: offsetValue,
                unit: item.value,
              });
            }}
          />
          <div className={styles.text}> ago</div>
        </>
      )}
    </div>
  );
}
